export default "__VITE_ASSET__Cnqn3R32__"